$( document ).ready(function() {


  const rdqueryString = window.location.search;

// Create a new URLSearchParams object
const rdurlParams = new URLSearchParams(rdqueryString);

// Get the value of a specific parameter
const rd = rdurlParams.get('r');
const go = rdurlParams.get('g');
if (rd==1 && go !=1){ 
  
  document.getElementById("modal_head").innerHTML="<br><center>&nbsp;&nbsp;&nbsp;&nbsp;Added To Favorites.&nbsp;&nbsp;&nbsp;&nbsp;<br><br></center>"; 
   
                 document.getElementById("modal_desc").innerHTML="";
                 document.getElementById("closebtn").style.display="block" ; 
                toggleModal();



 
}

const favoritesButton = document.getElementById('add-to-favorites-button');
const remdiv = document.getElementById('rem_fav_div');
const adddiv = document.getElementById('add_fav_div');

let pid = '';
let check_type=0
if (document.getElementById('product_id')){
pid = document.getElementById('product_id');
check_type=1;
}else if (document.getElementById('collection_id')){
pid = document.getElementById('collection_id');
check_type=2;
}
const cid = document.getElementById('customer_number');  
  // Check if the button actually exists on the current page
  if (favoritesButton && pid && cid) {

if (pid){ 
  if (check_type==1){ 
 var product_id= document.getElementById('product_id').innerHTML;
  }
   if (check_type==2){ 
 var product_id= document.getElementById('collection_id').innerHTML;
  }
  if (product_id){
    var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
    var product_id = product_id.replace("</a>", ""); 
  }
}

if (cid){   
 var cust_id= document.getElementById('customer_number').innerHTML;
  if (cust_id){
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", "");
  }
}    
    
 $.post("https://buylocalus.com/apps/blusapp/check_wishlist.php",{product_id:product_id,cust_id:cust_id,check_type:check_type},function(data){
    if (data>0){
      if (adddiv){
document.getElementById('add_fav_div').style.display="none";
      }

      if (remdiv){
document.getElementById('rem_fav_div').style.display="block";
      }
      
    }

 })

  }
})




function update_favorites(type,product_type){
const adddiv = document.getElementById('add_fav_div');
const remdiv = document.getElementById('rem_fav_div');

if (product_type==4){
const pid = document.getElementById('collection_id');
var product_id= document.getElementById('collection_id').innerText;
  //if (product_id){
   // var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
   // var product_id = product_id.replace("</a>", ""); 
  //}
}else{
const pid = document.getElementById('product_id');
var product_id= document.getElementById('product_id').innerText;
  //if (product_id){
   // var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
   // var product_id = product_id.replace("</a>", ""); 
  //}
} 
const vid = document.getElementById('cur_var_id'); 
const cid = document.getElementById('customer_number');
const spcid = document.getElementById('spon_col_id'); 
const spin = document.getElementById('spinner_fav');   
const status = type;
  

var sub_error=0;
///type 1 = add, 2 = remove
if (spin){
if (type==1){
document.getElementById('add_fav_div').style.display="none";  
document.getElementById('spinner_fav').style.display="block";
  
}

if (type==2){
document.getElementById('rem_fav_div').style.display="none";  
document.getElementById('spinner_fav').style.display="block";
  
}  

  
}  


if (product_id){  
 
}else{
 
 var sub_error=1; 
}
  
if (vid){ 
 var variant_id= document.getElementById('cur_var_id').value;
  if (variant_id){
   var variant_id = variant_id.replace("<a href=\"javascript: void(0)\">", "");
    var variant_id = variant_id.replace("</a>", ""); 
  }
}else{
var variant_id='';
  
}

if (spcid){ 
 var collection_id= document.getElementById('spon_col_id').innerHTML;

  if (collection_id){
   var collection_id = collection_id.replace("<a href=\"javascript: void(0)\">", "");
    var collection_id = collection_id.replace("</a>", ""); 
  }
}else{
var collection_id='';
  
}  

if (cid){   
 var cust_id= document.getElementById('customer_number').innerHTML;
  if (cust_id){
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", "");
  }
}else{
var sub_error=1;
  
}  

if (sub_error==1){
alert('There was an error with your submission. Please refresh the page and try again.');

if (spin){
if (type==1){
document.getElementById('add_fav_div').style.display="block";  
document.getElementById('spinner_fav').style.display="none";
  
}

if (type==2){
document.getElementById('rem_fav_div').style.display="block";  
document.getElementById('spinner_fav').style.display="none";
  
}  

  
}    
  
}else{

var ovexists=document.getElementById('owner_viewing'); 
  if (ovexists){
  var owner_viewing=1;
  }else{
var owner_viewing=0;

  }

if (owner_viewing==0){
 $.post("https://buylocalus.com/apps/blusapp/add_to_wishlist.php",{product_id:product_id,status:status,cust_id:cust_id,variant_id:variant_id,collection_id:collection_id,product_type:product_type,owner_viewing:owner_viewing},function(data){
         //alert(data);
 var results=data.split('|');

       var wlpid=results[0];
       var wlstatus=results[1];

 

   //var wlpid='1';

if (type==1){

if (spin){
document.getElementById('spinner_fav').style.display="none";
}

 if (wlpid==product_id){   
if (adddiv){  
document.getElementById('add_fav_div').style.display='none';
}
  if (remdiv){  
document.getElementById('rem_fav_div').style.display='block';  
  }
 }else{

 document.getElementById('add_fav_div').style.display='block';  
 }

 if (wlpid==product_id){  
 document.getElementById("modal_head").innerHTML="<br><center>Added To Favorites.<br><br></center>"; 
 }else{
 document.getElementById("modal_head").innerHTML="<br><center>There was an error with your submission. Please refresh the page and try again.<br><br></center>"; 
 }
                   document.getElementById("modal_desc").innerHTML="";
                   document.getElementById("closebtn").style.display="block" ; 
                  toggleModal();


  
}
if (type==2){
if (spin){
document.getElementById('spinner_fav').style.display="none";
}
 if (wlpid==product_id){   
 if (remdiv){  
document.getElementById('rem_fav_div').style.display='none';  
  }  
if (adddiv){  
document.getElementById('add_fav_div').style.display='block';
}
 }else{

 document.getElementById('rem_fav_div').style.display='block';  
 }
  
 if (wlpid==product_id){ 
document.getElementById("modal_head").innerHTML="<br><center>Removed From Favorites.<br><br></center>"; 
   }else{
 document.getElementById("modal_head").innerHTML="<br><center>There was an error with your submission. Please refresh the page and try again.<br><br></center>"; 
 }
                   document.getElementById("modal_desc").innerHTML="";
                   document.getElementById("closebtn").style.display="block" ; 
                  toggleModal();
  
 
} 
   


 })
}else{

document.getElementById("modal_head").innerHTML="<br><center>Added To Favorites.<br>(You are previewing. No record added to favorites)<br><br></center>"; 
 
                   document.getElementById("modal_desc").innerHTML="";
                   document.getElementById("closebtn").style.display="block" ; 
                  toggleModal();
                  document.getElementById('spinner_fav').style.display="none";
                  document.getElementById('add_fav_div').style.display='block';

}
 }  
  


    


}